import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import FormatDate from '../../Utils/FormatDate';
import classes from './styles.module.css';
import Context from '../../../Context';

function MobileCard({ data = {}, currentUuid }) {
    const { onSelectProjectUuid } = useContext(Context);

    let statusId;
    let statusDefault;
    let color;

    if (typeof data.status === 'string') {
        switch (data.status) {
            case 'Status.active':
                statusId = 'Status.active';
                statusDefault = 'Активен';
                color = 'rgb(16,150,24)';
                break;
            case 'Status.inactive':
                statusId = 'Status.inactive';
                statusDefault = 'Не активна';
                color = '#ff9900';
                break;
            case 'Status.blocked':
                statusId = 'Status.blocked';
                statusDefault = 'Заблокирован';
                color = 'rgb(220,57,18)';
                break;
            default:
                statusId = 'Status.unknown';
                statusDefault = 'Неизвестно';
                color = '#999';
        }
    } else {
        switch (data.status) {
            case 1:
                statusId = 'AccountsList.status.active';
                statusDefault = 'Активен';
                color = 'rgb(16,150,24)';
                break;
            case -1:
                statusId = 'AccountsList.status.inactive';
                statusDefault = 'Не активна';
                color = '#ff9900';
                break;
            case -2:
                statusId = 'AccountsList.status.closed';
                statusDefault = 'Закрыт';
                color = '#d4d4d4';
                break;
            case -3:
                statusId = 'AccountsList.status.blocked';
                statusDefault = 'Заблокирован';
                color = 'rgb(220,57,18)';
                break;
            default:
                statusId = 'Status.unknown';
                statusDefault = 'Неизвестно';
                color = '#999';
        }
    }

    const identity = data.uuid || data.id || '-';
    const isActive = currentUuid === data.uuid;

    return (
        <div
            className={classes.MobileCard}
            onClick={() => data.uuid && onSelectProjectUuid && onSelectProjectUuid(data.uuid)}
            role='button'
            style={isActive ? { borderBottomColor: color } : null}
        >
            <div className={classes.MobilePrimary}>
                <span className={classes.MobileName}>{data.name || '-'}</span>
                <span className={classes.MobileStatus} style={{ color }}>
                    <FormattedMessage id={statusId} defaultMessage={statusDefault} />
                </span>
            </div>

            <div className={classes.MobileMetaRow}>
                <span className={classes.MobileMeta}>{identity}</span>
                <span className={classes.MobileMeta}>
                    <FormatDate
                        setDate={data.createdAt}
                        format={{ day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }}
                    />
                </span>
            </div>

            <div className={classes.MobileField}>
                <span className={classes.MobileValue}>{data.url || '-'}</span>
            </div>
        </div>
    );
}

export default MobileCard;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectsList/MobileCard.js